import { render, staticRenderFns } from "./single.vue?vue&type=template&id=141f6d5a&scoped=true&"
import script from "./single.vue?vue&type=script&lang=js&"
export * from "./single.vue?vue&type=script&lang=js&"
import style0 from "./single.vue?vue&type=style&index=0&id=141f6d5a&prod&lang=scss&"
import style1 from "./single.vue?vue&type=style&index=1&id=141f6d5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141f6d5a",
  null
  
)

export default component.exports